import { capitalize, uniqueId } from 'lodash'
import { addNotification } from 'components/Notifications/actions'
import { DEFAULT_HEADER_HEIGHT } from 'pages/Administration/constants'

export const sendNotification = ({ t, info, kind, message }) => {
  const tPath = 'Administration:RolesManagement.Notification'
  const captionLabel = `${info}${kind === 'error' ? 'Error' : ''}`

  const title = t(`${tPath}.${capitalize(kind)}`)
  const caption = message || t(`${tPath}.${captionLabel}`)

  addNotification({
    id: uniqueId('notif-'),
    type: kind === 'error' ? 'toast' : 'inline',
    kind,
    title,
    message: kind !== 'error' && caption,
    caption: kind === 'error' && caption
  })
}

export const sizeTableToFit = (gridApi) => {
  gridApi.setHeaderHeight(DEFAULT_HEADER_HEIGHT)
  gridApi.setFloatingFiltersHeight(DEFAULT_HEADER_HEIGHT)
  gridApi.sizeColumnsToFit()
}

function cell(text, styleId) {
  return {
    styleId: styleId,
    data: {
      type: /^\d+$/.test(text) ? 'Number' : 'String',
      value: String(text)
    }
  }
}

export const excelStyles = [
  {
    id: 'header',
    interior: {
      color: '#aaaaaa',
      pattern: 'Solid'
    }
  },
  {
    id: 'body',
    interior: {
      color: '#ffff66',
      pattern: 'Solid'
    }
  }
]

export const defaultExportParams = (t) => {
  return {
    getCustomContentBelowRow: function (params) {
      const detailBody = []
      if (params.node.data.children.length > 0) {
        params.node.data.children.map((detail) => {
          detailBody.push([
            cell(''),
            cell(detail.title, 'detailBody', 'String'),
            cell(detail.instanceTitle, 'detailBody', 'String'),
            cell(detail.workingTableTitle, 'detailBody', 'String'),
            cell(detail.documentType, 'detailBody', 'String'),
            cell(detail.roleName, 'detailBody', 'String'),
            cell(detail.permission.read, 'detailBody', 'String'),
            cell(detail.permission.create, 'detailBody', 'String'),
            cell(detail.permission.update, 'detailBody', 'String'),
            cell(detail.permission.delete, 'detailBody', 'String'),
            cell(detail.permission.import_, 'detailBody', 'String'),
            cell(detail.permission.export, 'detailBody', 'String')
          ])
        })

        const detailHeader = [
          [
            cell(''),
            cell(t('RolesManagement.DocumentFieldsColumn.Name'), 'header'),
            cell(t('RolesManagement.DocumentFieldsColumn.Instance'), 'header'),
            cell(
              t('RolesManagement.DocumentFieldsColumn.WorkingTable'),
              'header'
            ),
            cell(t('RolesManagement.DocumentTypesColumn.Type'), 'header'),
            cell(t('RolesManagement.DocumentFieldsColumn.Role'), 'header'),
            cell(t('RolesManagement.RolesColumn.Read'), 'header'),
            cell(t('RolesManagement.RolesColumn.Create'), 'header'),
            cell(t('RolesManagement.RolesColumn.Update'), 'header'),
            cell(t('RolesManagement.RolesColumn.Delete'), 'header'),
            cell(t('RolesManagement.RolesColumn.Import'), 'header'),
            cell(t('RolesManagement.RolesColumn.Export'), 'header')
          ]
        ]
        return [...detailHeader, ...detailBody]
      }
      return []
    }
  }
}

export const onExportFieldData = (gridApi, columnApi, fileName) => {
  const columnToExport = columnApi.getAllDisplayedColumns()

  const param = {
    fileName: fileName + '.xlsx',
    sheetName: fileName,
    columnWidth: 100,
    columnKeys: columnToExport,
    processCellCallback: (params) => {
      const { column, node, value } = params
      const colDef = column.getColDef()
      if (colDef.valueFormatter) {
        const valueFormatterParams = {
          ...params,
          node,
          colDef,
          data: node.data
        }
        return colDef.valueFormatter(valueFormatterParams)
      }
      return value
    }
  }
  gridApi.exportDataAsExcel(param)
}
export const defaultExportParamsOutput = (t) => {
  return {
    getCustomContentBelowRow: function (params) {
      const detailBody = []
      if (params.node.data.permissions.length > 0) {
        params.node.data.permissions.map((detail) => {
          detailBody.push([
            cell(''),
            cell(
              detail?.outputField
                ? t(`OutputView:${detail.outputField}.TITLE`)
                : '',
              'body'
            ),
            cell(detail.read.toString(), 'body')
          ])
        })

        const detailHeader = [
          [
            cell(''),
            cell(t('OutputManagement.Page'), 'header'),
            cell(t('RolesManagement.RolesColumn.Read'), 'header')
          ]
        ]
        return [...detailHeader, ...detailBody]
      }
      return []
    }
  }
}

export const onExportDataOutput = (gridApi, columnApi, customFileName, t) => {
  const columnToExport = columnApi.getAllDisplayedColumns()

  gridApi.exportDataAsExcel({
    fileName: customFileName + '.xlsx',
    sheetName: customFileName,
    columnKeys: columnToExport,
    columnWidth: 120
  })
}

export const onExportData = (gridApi, columnApi, customFileName) => {
  const columnToExport = columnApi.getAllDisplayedColumns()

  gridApi.exportDataAsExcel({
    fileName: customFileName + '.xlsx',
    sheetName: customFileName,
    columnKeys: columnToExport,
    processCellCallback: (params) => {
      const { column, node, value } = params

      const colDef = column.getColDef()
      if (colDef.valueFormatter) {
        const valueFormatterParams = {
          ...params,
          node,
          colDef,
          data: node.data
        }
        return colDef.valueFormatter(valueFormatterParams)
      }
      return value
    }
  })
}

export const getSimpleNodeId = (data) => data.id

export const getRowNodeId = (data) => data.ubliqueId

export const handleColumnDefs = (columnDefs, t) => {
  return columnDefs.map((col) => ({
    ...col,
    headerName: t(col.headerName),
    headerTooltip: t(col.headerTooltip)
  }))
}

export const onPermissionsLabelChange = {
  read: () => 1,
  create: () => 4,
  update: () => 5,
  delete: () => 6,
  import: () => 2,
  export: () => 3
}

export const detailCellRendererParams = {
  detailGridOptions: {
    // ...gridOptions
  },
  getDetailRowData: (params) => {
    params.successCallback(params.data.callRecords)
  }
}

export const hasChildren = (item) =>
  Boolean(item.children && item.children.length)

export const isOpen = (id, selectedItems) => Boolean(selectedItems[id])

export const getLeveledPadding = (level) => ({
  paddingLeft: `${level} * 30px`
})
